import type { GatsbyBrowser } from 'gatsby';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import type { GlobalPageContext } from './src/@types/app';
import Layout from './src/layout';
import PageWrapper from './src/layout/page-wrapper';
import './src/styles/global.css';

const isBlogListingPath = (pathname: string) =>
  /^\/blogs\/(?:[^/]+\/)?\d+\/?$/.test(pathname);

const getBlogListingScrollY = () => {
  const anchor = document.getElementById('blog-listing-scroll-anchor');
  if (!anchor) return null;

  const headerHeight = Number.parseFloat(
    getComputedStyle(document.documentElement).getPropertyValue(
      '--header-total-height',
    ) || '116',
  );

  const top =
    anchor.getBoundingClientRect().top + window.pageYOffset - headerHeight;

  return Math.max(0, top);
};

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = ({
  prevRouterProps,
  routerProps,
}) => {
  const prevPath = prevRouterProps?.location?.pathname ?? '';
  const nextPath = routerProps?.location?.pathname ?? '';

  if (isBlogListingPath(prevPath) && isBlogListingPath(nextPath)) {
    const scrollY = getBlogListingScrollY();
    if (scrollY !== null) {
      return [0, scrollY];
    }
    return false;
  }

  return true;
};

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({  element,
}) => {
  return (
    <Layout>
      {element}
      <ToastContainer hideProgressBar theme="colored" />
    </Layout>
  );
};

export const wrapPageElement: GatsbyBrowser<
  unknown,
  GlobalPageContext
>['wrapPageElement'] = ({ element, props }) => {
  return (
    <PageWrapper disableFadePage={props.pageContext.disableFadePage}>
      {element}
    </PageWrapper>
  );
};
